import moment from "moment";

export function formatDateRange(start: string, end: string) {
  const mStart = moment(start);
  const mEnd = moment(end);

  if (mStart.isSame(mEnd, "day")) {
    return `${mStart.format("DD MMM YYYY")}`;
  }
  if (mStart.isSame(mEnd, "month")) {
    return `${mStart.format("DD")}–${mEnd.format("DD MMM YYYY")}`;
  }
  return `${mStart.format("DD MMM")}–${mEnd.format("DD MMM YYYY")}`;
}
